/* pkl-calculator-core-v5.js
   SindeBella / Shopify + T Lab safe price calculator
   Version: V5 full-site component

   How it works:
   - Load this file once in theme.liquid before </body>.
   - It auto-runs only when a page contains a calculator product list.
   - It supports multiple calculators on one page.
   - It never reads visible translated price text.
   - Best practice for every product row:
       data-pkl-name="Lip Gloss"
       data-pkl-cents="268"
       data-pkl-moq="500"
*/

(function(){
  'use strict';

  if (window.__PKL_CALCULATOR_CORE_V5__) return;
  window.__PKL_CALCULATOR_CORE_V5__ = true;

  var DEFAULT_RATES = {
    USD: 1,
    EUR: 0.92,
    GBP: 0.79,
    CAD: 1.37,
    AUD: 1.52,
    AED: 3.67,
    SAR: 3.75
  };

  var DEFAULT_SYMBOLS = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: 'C$',
    AUD: 'A$',
    AED: 'AED ',
    SAR: 'SAR '
  };

  var CURRENCY_LABELS = {
    USD: 'USD - US Dollar',
    EUR: 'EUR - Euro',
    GBP: 'GBP - British Pound',
    CAD: 'CAD - Canadian Dollar',
    AUD: 'AUD - Australian Dollar',
    AED: 'AED - UAE Dirham',
    SAR: 'SAR - Saudi Riyal'
  };

  var BUTTON_TEXT = {
    en: { add: 'Add to quote', added: 'Added to quote' },
    es: { add: 'Añadir al presupuesto', added: 'Añadido al presupuesto' },
    fr: { add: 'Ajouter au devis', added: 'Ajouté au devis' },
    de: { add: 'Zum Angebot hinzufügen', added: 'Zum Angebot hinzugefügt' },
    nl: { add: 'Toevoegen aan offerte', added: 'Toegevoegd aan offerte' },
    ar: { add: 'أضف إلى عرض السعر', added: 'تمت الإضافة إلى عرض السعر' }
  };

  var PINK_DEFAULT_PRODUCTS = [
    { name: 'Lip Gloss',          cents: 268, moq: 500 },
    { name: 'Lip Oil',            cents: 248, moq: 500 },
    { name: 'Liquid Lipstick',    cents: 275, moq: 500 },
    { name: 'Lipstick',           cents: 255, moq: 500 },
    { name: 'Powder Highlighter', cents: 290, moq: 500 },
    { name: 'Blush Stick',        cents: 290, moq: 500 },
    { name: 'Liquid Blush',       cents: 285, moq: 500 },
    { name: 'Mascara',            cents: 245, moq: 500 }
  ];

  var CONFIG = window.PKL_CALCULATOR_CONFIG || {};
  var RATES = Object.assign({}, DEFAULT_RATES, CONFIG.rates || {});
  var SYMBOLS = Object.assign({}, DEFAULT_SYMBOLS, CONFIG.symbols || {});

  var state = {
    instances: [],
    bound: false,
    selectedCurrency: null
  };

  function getLang(){
    var path = window.location.pathname || '';
    var htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();

    if (path.indexOf('/fr/') === 0 || htmlLang.indexOf('fr') === 0) return 'fr';
    if (path.indexOf('/de/') === 0 || htmlLang.indexOf('de') === 0) return 'de';
    if (path.indexOf('/ar/') === 0 || htmlLang.indexOf('ar') === 0) return 'ar';
    if (path.indexOf('/nl/') === 0 || htmlLang.indexOf('nl') === 0) return 'nl';
    if (path.indexOf('/es/') === 0 || htmlLang.indexOf('es') === 0) return 'es';

    return 'en';
  }

  function closestCalculatorRoot(productList){
    return (
      productList.closest('[data-pkl-calculator]') ||
      productList.closest('.pkl-calculator') ||
      productList.closest('.pink-global-landing') ||
      productList.closest('section') ||
      document
    );
  }

  function qs(selector, base){
    return (base || document).querySelector(selector);
  }

  function qsa(selector, base){
    return Array.prototype.slice.call((base || document).querySelectorAll(selector));
  }

  function lockNode(el){
    if (!el) return;
    el.classList.add('notranslate');
    el.setAttribute('translate', 'no');
    el.setAttribute('data-no-translation', 'true');
    el.setAttribute('data-translation', 'off');
  }

  function safeInt(value){
    if (value === null || value === undefined) return null;
    var str = String(value).trim();
    if (!str) return null;
    str = str.replace(/[^\d-]/g, '');
    var num = parseInt(str, 10);
    return isNaN(num) ? null : num;
  }

  function safeDecimalToCents(value){
    if (value === null || value === undefined) return null;
    var str = String(value).trim();
    if (!str) return null;

    /* Support 2.68 and 2,68, but do not read visible text. */
    str = str.replace(/\s/g, '').replace(',', '.');
    var match = str.match(/-?\d+(\.\d+)?/);
    if (!match) return null;

    var num = parseFloat(match[0]);
    if (isNaN(num) || num <= 0) return null;

    return Math.round(num * 100);
  }

  function getPinkFallback(index){
    if ((window.location.pathname || '').indexOf('private-label-pink-makeup-collection') !== -1) {
      return PINK_DEFAULT_PRODUCTS[index] || null;
    }
    return null;
  }

  function readProduct(row, index){
    /*
      Strongest priority:
      1. Cached JS data from first successful read.
      2. Integer cents attributes. These are safest for translation apps.
      3. Price decimals from data attributes.
      4. Pink page fallback only for the existing pink collection page.
    */
    if (row.__pklProductV5 && row.__pklProductV5.cents > 0) {
      return row.__pklProductV5;
    }

    var name =
      row.getAttribute('data-pkl-name') ||
      row.getAttribute('data-name') ||
      row.getAttribute('data-original-name') ||
      (qs('[data-original-name]', row) ? qs('[data-original-name]', row).getAttribute('data-original-name') : '') ||
      (qs('h3', row) ? qs('h3', row).textContent.trim() : '') ||
      ('Product ' + (index + 1));

    var cents =
      safeInt(row.getAttribute('data-pkl-cents')) ||
      safeInt(row.getAttribute('data-usd-cents')) ||
      safeInt(row.getAttribute('data-price-cents')) ||
      safeInt(row.getAttribute('data-pkl-fixed-price-cents'));

    var moq =
      safeInt(row.getAttribute('data-pkl-moq')) ||
      safeInt(row.getAttribute('data-moq')) ||
      safeInt(row.getAttribute('data-pkl-fixed-moq')) ||
      null;

    if (!cents || cents <= 0) {
      cents =
        safeDecimalToCents(row.getAttribute('data-usd-price')) ||
        safeDecimalToCents(row.getAttribute('data-price')) ||
        safeDecimalToCents(row.getAttribute('data-base-price'));
    }

    if (!cents || cents <= 0) {
      var fallback = getPinkFallback(index);
      if (fallback) {
        name = row.getAttribute('data-pkl-name') || row.getAttribute('data-name') || fallback.name;
        cents = fallback.cents;
        moq = moq || fallback.moq;
      }
    }

    if (!moq || moq <= 0) moq = 500;
    if (!cents || cents <= 0) cents = 0;

    var product = {
      name: name,
      cents: cents,
      moq: moq,
      index: index
    };

    row.__pklProductV5 = product;
    return product;
  }

  function normalizeProductRow(row, index){
    var product = readProduct(row, index);
    var usd = product.cents / 100;

    row.setAttribute('data-pkl-index', String(index));
    row.setAttribute('data-pkl-name', product.name);
    row.setAttribute('data-pkl-cents', String(product.cents));
    row.setAttribute('data-pkl-moq', String(product.moq));
    row.setAttribute('data-usd-price', usd.toFixed(2));
    row.setAttribute('data-price', usd.toFixed(2));
    row.setAttribute('data-moq', String(product.moq));

    var pill = qs('.pkl-pill, [data-pkl-price-label]', row);
    lockNode(pill);

    var qty = qs('.pkl-qty, [data-pkl-qty]', row);
    if (qty) {
      qty.setAttribute('min', String(product.moq));
      qty.setAttribute('step', qty.getAttribute('step') || '100');

      var qtyValue = safeInt(qty.value);
      if (!qtyValue || qtyValue < product.moq) qty.value = String(product.moq);
    }

    var btn = qs('.pkl-add-btn, [data-pkl-add]', row);
    if (btn) {
      btn.setAttribute('type', 'button');
      var texts = BUTTON_TEXT[getLang()] || BUTTON_TEXT.en;
      btn.textContent = row.classList.contains('is-selected') ? texts.added : texts.add;
    }

    return product;
  }

  function findProductLists(){
    var lists = qsa('[data-pkl-product-list], #pklProductList');

    /* Deduplicate because one element can match both selectors. */
    var unique = [];
    lists.forEach(function(list){
      if (unique.indexOf(list) === -1) unique.push(list);
    });

    return unique;
  }

  function buildInstances(){
    var productLists = findProductLists();

    state.instances = productLists.map(function(productList, instanceIndex){
      var root = closestCalculatorRoot(productList);

      return {
        id: root.getAttribute('data-pkl-calculator') || ('pkl-calculator-' + instanceIndex),
        root: root,
        productList: productList
      };
    });
  }

  function findInsideOrGlobal(instance, selectors){
    for (var i = 0; i < selectors.length; i++) {
      var local = qs(selectors[i], instance.root);
      if (local) return local;
    }

    for (var j = 0; j < selectors.length; j++) {
      var global = qs(selectors[j], document);
      if (global) return global;
    }

    return null;
  }

  function getRows(instance){
    return qsa('[data-pkl-product-row], .pkl-row', instance.productList);
  }

  function getCurrencySelect(instance){
    return findInsideOrGlobal(instance, ['[data-pkl-currency]', '#pklCurrency']);
  }

  function getCurrencyCode(instance){
    var select = getCurrencySelect(instance);

    if (state.selectedCurrency && RATES[state.selectedCurrency]) {
      return state.selectedCurrency;
    }

    if (select && select.value && RATES[String(select.value).toUpperCase()]) {
      return String(select.value).toUpperCase();
    }

    return 'USD';
  }

  function getCurrency(instance){
    var code = getCurrencyCode(instance);

    return {
      code: code,
      rate: RATES[code] || 1,
      symbol: SYMBOLS[code] || (code + ' ')
    };
  }

  function normalizeCurrencySelect(instance){
    var select = getCurrencySelect(instance);
    if (!select) return;

    lockNode(select);

    var current = getCurrencyCode(instance);

    Object.keys(CURRENCY_LABELS).forEach(function(code){
      var option = null;

      Array.prototype.forEach.call(select.options, function(opt){
        if (String(opt.value || '').toUpperCase() === code) {
          option = opt;
        }
      });

      if (!option) {
        option = document.createElement('option');
        option.value = code;
        select.appendChild(option);
      }

      option.value = code;
      option.textContent = CURRENCY_LABELS[code];
      option.setAttribute('data-rate', String(RATES[code]));
      option.setAttribute('data-symbol', SYMBOLS[code] || (code + ' '));
      lockNode(option);
    });

    select.value = current;
  }

  function money(value, symbol, decimals){
    var num = Number(value || 0);
    return (symbol || '$') + num.toLocaleString(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  function setPriceLabel(row, product, cur){
    var pill = qs('.pkl-pill, [data-pkl-price-label]', row);
    if (!pill) return;

    lockNode(pill);

    var priceUsd = product.cents / 100;

    if (product.cents <= 0) {
      pill.textContent = 'Price on request · MOQ ' + product.moq + ' pcs';
      return;
    }

    if (cur.code === 'USD') {
      pill.textContent = 'USD ' + priceUsd.toFixed(2) + ' / pc · MOQ ' + product.moq + ' pcs';
    } else {
      pill.textContent =
        money(priceUsd * cur.rate, cur.symbol, 2) +
        ' / pc · MOQ ' +
        product.moq +
        ' pcs · approx. USD ' +
        priceUsd.toFixed(2);
    }
  }

  function updateHiddenFields(instance, lines, subtotalUsd, totalUnits, cur){
    var form =
      qs('[data-pkl-form]', instance.root) ||
      qs('#pklPinkForm', instance.root) ||
      qs('form', instance.root) ||
      qs('#pklPinkForm', document);

    if (!form) return;

    var selectedField =
      qs('[data-pkl-selected-products]', form) ||
      qs('#pklSelectedProductsField', form) ||
      qs('input[name="contact[Selected Pink Collection Products]"]', form) ||
      qs('input[name="contact[Selected Products]"]', form);

    var budgetField =
      qs('[data-pkl-estimated-budget]', form) ||
      qs('#pklEstimatedBudgetField', form) ||
      qs('input[name="contact[Estimated Budget]"]', form);

    if (!selectedField || !budgetField) return;

    if (lines.length > 0) {
      selectedField.disabled = false;
      budgetField.disabled = false;

      selectedField.value = lines.join('\n');
      budgetField.value = [
        'Customer used the product cost estimator.',
        'Estimated product subtotal: USD ' + subtotalUsd.toFixed(2),
        'Selected currency estimate: ' + cur.code + ' ' + (subtotalUsd * cur.rate).toFixed(2),
        'Total selected units: ' + totalUnits,
        'Note: Shipping, testing, documents, packaging details and taxes are quoted separately.'
      ].join('\n');
    } else {
      selectedField.value = '';
      budgetField.value = '';
      selectedField.disabled = true;
      budgetField.disabled = true;
    }
  }

  function updateSummary(instance, selectedCount, totalUnits, subtotalUsd, cur){
    var selectedCountEl = findInsideOrGlobal(instance, ['[data-pkl-selected-count]', '#pklSelectedCount']);
    var totalUnitsEl = findInsideOrGlobal(instance, ['[data-pkl-total-units]', '#pklTotalUnits']);
    var subtotalEl = findInsideOrGlobal(instance, ['[data-pkl-subtotal]', '#pklProductSubtotal']);
    var grandTotalEl = findInsideOrGlobal(instance, ['[data-pkl-grand-total]', '#pklGrandTotal']);

    lockNode(selectedCountEl);
    lockNode(totalUnitsEl);
    lockNode(subtotalEl);
    lockNode(grandTotalEl);

    if (selectedCountEl) selectedCountEl.textContent = String(selectedCount);
    if (totalUnitsEl) totalUnitsEl.textContent = totalUnits.toLocaleString();
    if (subtotalEl) subtotalEl.textContent = money(subtotalUsd * cur.rate, cur.symbol, 0);
    if (grandTotalEl) grandTotalEl.textContent = money(subtotalUsd * cur.rate, cur.symbol, 0) + ' ' + cur.code;
  }

  function calculateInstance(instance){
    normalizeCurrencySelect(instance);

    var cur = getCurrency(instance);
    var rows = getRows(instance);

    var selectedCount = 0;
    var totalUnits = 0;
    var subtotalUsd = 0;
    var lines = [];

    rows.forEach(function(row, index){
      var product = normalizeProductRow(row, index);
      setPriceLabel(row, product, cur);

      var qtyInput = qs('.pkl-qty, [data-pkl-qty]', row);
      var qty = qtyInput ? safeInt(qtyInput.value) : product.moq;

      if (!qty || qty < product.moq) {
        qty = product.moq;
        if (qtyInput) qtyInput.value = String(product.moq);
      }

      if (row.classList.contains('is-selected')) {
        var lineUsd = qty * (product.cents / 100);

        selectedCount += 1;
        totalUnits += qty;
        subtotalUsd += lineUsd;

        lines.push(
          product.name +
          ' — ' +
          qty +
          ' pcs, USD ' +
          (product.cents / 100).toFixed(2) +
          ' / pc, subtotal USD ' +
          lineUsd.toFixed(2)
        );
      }
    });

    updateSummary(instance, selectedCount, totalUnits, subtotalUsd, cur);
    updateHiddenFields(instance, lines, subtotalUsd, totalUnits, cur);
  }

  function calculateAll(){
    if (!state.instances.length) buildInstances();
    state.instances.forEach(calculateInstance);
  }

  function bindEvents(){
    if (state.bound) return;
    state.bound = true;

    document.addEventListener('change', function(e){
      if (e.target && (e.target.matches('[data-pkl-currency]') || e.target.id === 'pklCurrency')) {
        state.selectedCurrency = String(e.target.value || 'USD').toUpperCase();
        calculateAll();
        return;
      }

      if (e.target && (e.target.matches('[data-pkl-qty]') || e.target.classList.contains('pkl-qty'))) {
        calculateAll();
      }
    }, true);

    document.addEventListener('input', function(e){
      if (e.target && (e.target.matches('[data-pkl-qty]') || e.target.classList.contains('pkl-qty'))) {
        calculateAll();
      }
    }, true);

    document.addEventListener('click', function(e){
      var btn = e.target && e.target.closest ? e.target.closest('[data-pkl-add], .pkl-add-btn') : null;
      if (!btn) return;

      var row = btn.closest('[data-pkl-product-row], .pkl-row');
      if (!row) return;

      var productList = row.closest('[data-pkl-product-list], #pklProductList');
      if (!productList) return;

      e.preventDefault();
      e.stopPropagation();

      row.classList.toggle('is-selected');
      calculateAll();
    }, true);

    document.addEventListener('submit', function(e){
      if (e.target && (e.target.matches('[data-pkl-form]') || e.target.id === 'pklPinkForm')) {
        calculateAll();
      }
    }, true);
  }

  function start(){
    buildInstances();

    if (!state.instances.length) return;

    bindEvents();
    calculateAll();

    /* T Lab may rewrite translated content after page load. Re-apply fixed prices. */
    [100, 300, 700, 1200, 2000, 3500, 5500, 8500, 12000, 16000].forEach(function(ms){
      window.setTimeout(function(){
        buildInstances();
        calculateAll();
      }, ms);
    });

    if (window.MutationObserver) {
      var timer = null;
      var observer = new MutationObserver(function(){
        window.clearTimeout(timer);
        timer = window.setTimeout(function(){
          buildInstances();
          calculateAll();
        }, 180);
      });

      state.instances.forEach(function(instance){
        if (instance.root && instance.root !== document) {
          observer.observe(instance.root, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['class', 'data-price', 'data-usd-price', 'data-pkl-cents', 'data-moq']
          });
        }
      });

      window.setTimeout(function(){
        try { observer.disconnect(); } catch(e) {}
      }, 22000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

})();
